// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__38KZe","full":"container_full__15t-o"};